import { BaseModel } from '@/models/BaseModel';
import { BaseCollection } from './BaseCollection';
import type { MutationsObject } from '@kp/js-model';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { createModel } from '@kp/js-model';

export class GwrEco2StatEnergieWaermequelle extends BaseModel {
    // properties
    id: number | null = null;
    created: Dayjs | null = null;
    modified: Dayjs | null = null;
    creator_id: number | null = null;
    modifier_id: number | null = null;

    zuordnung_energie_waermequelle_id: number | null = null;
    gwr_energie_waermequelle_id: number | null = null;

    // view fields:
    gwr_energie_waermequelle_i18n_key: string | null = null;
    gwr_energie_waermequelle_code: number | null = null;

    public mutations(): MutationsObject {
        return {
            created: (val) => dayjs(val),
            modified: (val) => dayjs(val),
        };
    }

    getClassName(): string {
        return 'GwrEco2StatEnergieWaermequelle';
    }
}

export async function createNewGwrEco2StatEnergieWaermequelle(): Promise<GwrEco2StatEnergieWaermequelle> {
    const model = createModel(GwrEco2StatEnergieWaermequelle, {});

    await model.save();
    return model;
}

export class GwrEco2StatEnergieWaermequelleCollection extends BaseCollection<GwrEco2StatEnergieWaermequelle> {
    protected modelCls = GwrEco2StatEnergieWaermequelle;

    public getModelClassName(): string {
        return 'GwrEco2StatEnergieWaermequelle';
    }
}
